<template>
  <b-card no-body>
    <!-- Header -->
    <b-card-header class="d-flex justify-content-between align-items-center">
      <h5 class="mb-0">
        logged In devices
      </h5>

      <b-button
        size="sm"
        variant="danger"
        @click="logoutAll"
      >
        Logout All
      </b-button>
    </b-card-header>

    <!-- Body -->
    <b-card-body>
      <b-table
        responsive
        striped
        hover
        show-empty
        empty-text="No logged in devices found"
        :items="devices"
        :fields="fields"
      >
        <!-- Device -->
        <template #cell(device)="data">
          <div class="d-flex align-items-center">
            <feather-icon
              :icon="data.item.icon"
              size="18"
              class="mr-75"
            />
            <div>
              <strong>{{ data.item.device }}</strong>

              <b-badge
                v-if="data.item.isCurrent"
                variant="success"
                class="ml-50"
              >
                Current
              </b-badge>

              <div class="text-muted font-small-2">
                {{ data.item.browser }} • {{ data.item.os }}
              </div>
            </div>
          </div>
        </template>

        <!-- Action -->
        <template #cell(action)="data">
          <b-button
            size="sm"
            variant="outline-danger"
            :disabled="data.item.isCurrent"
            @click="logoutDevice(data.item.id)"
          >
            Logout
          </b-button>
        </template>
      </b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BButton,
  BBadge,
} from 'bootstrap-vue'
import moment from 'moment'
import axiosIns from '@/libs/axios'
import { clearAuthStorage, getSessionId } from '@/auth/session'

export default {
  name: 'LoggedInDevices',

  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BButton,
    BBadge,
  },

  data() {
    return {
      loading: false,
      fields: [
        { key: 'device', label: 'Device' },
        { key: 'lastActive', label: 'Last Active' },
        { key: 'action', label: 'Action' },
      ],
      devices: [],
    }
  },
  created() {
    this.fetchSessions()
  },

  methods: {
    getSessionIcon(platform) {
      if (platform === 'iOS' || platform === 'Android') {
        return 'SmartphoneIcon'
      }
      return 'MonitorIcon'
    },
    async fetchSessions() {
      this.loading = true
      try {
        const response = await axiosIns.get('/api/users/sessions')
        const currentSessionId = getSessionId()
        const sessions = response?.data?.sessions || []

        this.devices = sessions.map(session => ({
          id: session.sessionId,
          device: session.device_name || 'Unknown device',
          browser: session.platform || 'Unknown',
          os: session.device_id || '-',
          lastActive: session.lastLogin ? moment(session.lastLogin).fromNow() : '-',
          icon: this.getSessionIcon(session.platform),
          isCurrent: session.sessionId === currentSessionId,
        }))
      } catch (error) {
        console.error('Failed to fetch sessions', error)
        this.devices = []
      } finally {
        this.loading = false
      }
    },
    async logoutDevice(sessionId) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        'Do you want to logout this device?',
        {
          title: 'Confirm Logout',
          okVariant: 'danger',
          okTitle: 'Logout',
          cancelTitle: 'Cancel',
          centered: true,
        },
      )
      if (!confirmed) {
        return
      }

      try {
        await axiosIns.post('/api/users/logout', { sessionId })
      } catch (error) {
        console.error('Failed to logout session', error)
      } finally {
        await this.fetchSessions()
      }
    },
    async logoutAll() {
      try {
        await axiosIns.post('/api/users/logout-all', {})
      } catch (error) {
        console.error('Failed to logout all sessions', error)
      } finally {
        clearAuthStorage()
        this.$router.push({ name: 'auth-login' })
      }
    },
  },
}
</script>

<style scoped>
.font-small-2 {
  font-size: 12px;
}
</style>
